<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>
              <span>Eventos de Contingencia</span>
            </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-select
              v-model="filtro"
              :items="filtros"
              :disabled="loading"
              return-object
              filled
              label="Filtrar"
              class="mt-6"
              dense
            />
            <v-select
              v-model="suc_sel"
              :items="sucursales"
              :loading="loadingsucursales"
              item-text="xtext"
              label="Seleccione el nit"
              return-object
              class=""
              outlined
              dense
              hide-details
            />
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Agregar
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="orange" small v-bind="attrs" v-on="on" @click="verItem(item)">
                mdi-eye
              </v-icon>
            </template>
            <span> Ver detalles </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="purple" small v-bind="attrs" v-on="on" @click="verItemFacturas(item)">
                mdi-clipboard-outline
              </v-icon>
            </template>
            <span> Ver Facturas </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion == null"
                class="mr-1"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="recepcionItem(item)"
              >
                mdi-clipboard-text-multiple-outline
              </v-icon>
            </template>
            <span> Emision por paquete </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion == null"
                class="mr-1"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="verEnvios(item)"
              >
                mdi-check-decagram
              </v-icon>
            </template>
            <span> Ver envios </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.codigoRecepcion != null"
                class="red--text"
                small
                v-bind="attrs"
                v-on="on"
                @click="finalizarItem(item)"
              >
                mdi-bomb
              </v-icon>
            </template>
            <span> Finalizar Evento </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <EventosReg ref="eventosreg" v-on:newregevento="newregevento" />
    <EventosView ref="eventoview" />
    <EventosRecep ref="eventosrecep" v-on:newregevento="newregevento" />
    <EventosViewf ref="eventosviewf" />
    <EventoFin ref="eventofin" v-on:eventoFinalizado="eventoFinalizado" />
  </div>
</template>

<script>
  import EventosReg from '@/views/recibos/esignificativos/registrar.vue';
  import EventosView from '@/views/recibos/esignificativos/eventoview.vue';
  import EventoFin from '@/views/recibos/esignificativos/finalizar.vue';
  import EventosViewf from '@/views/recibos/esignificativos/eventoviewfacturas.vue';
  import EventosRecep from '@/views/recibos/emisionpaq/recepcionpaquete.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      // headers: [
      //   { text: 'Nombre', value: 'nombre' },
      //   { text: 'Municipio', value: 'municipio' },
      //   { text: 'Telefono', value: 'telefono' },
      //   { text: 'Direccion', value: 'direccion' },
      //   { text: 'Codigo Sucursal', value: 'codigoSucursal' },
      //   { text: 'Opciones', value: 'opciones', sortable: false },
      // ],
      filtros: [
        { id: 1, text: 'Todos' },
        { id: 2, text: 'Finalizados' },
        { id: 3, text: 'No Finalizados' },
      ],
      filtro: null,
      headers: [
        { text: 'Codigo', value: 'codigo' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Codigo Punto Venta', value: 'puntoVenta.codigoPuntoVenta' },
        { text: 'Codigo Sucursal', value: 'sucursal.codigoSucursal' },
        { text: 'Codigo Recepcion', value: 'codigoRecepcion' },
        //{ text: 'Cufd Evento', value: 'cufdEvento' },
        { text: 'Fecha inicio', value: 'fecha_inicio' },
        { text: 'Fecha fin', value: 'fecha_fin' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 140 },
      ],
      dessertscopy: [],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },

      suc_sel: null,
      sucursales: [],
      nits: [],
      loadingsucursales: false,
    }),

    components: { EventosReg, EventosView, EventoFin, EventosViewf, EventosRecep },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      '$store.state.CARGO.sede': function() {
        this.getSucursalesBySede();
      },
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      filtro: function() {
        if (!this.filtro) return;
        window.console.log(this.filtro);
        this.desserts = [];
        let vue = this;
        if (this.filtro.id == 1) {
          this.dessertscopy.forEach((x) => {
            vue.desserts.push(x);
          });
        } else if (this.filtro.id == 2) {
          this.dessertscopy.forEach((x) => {
            if (x.codigoRecepcion) vue.desserts.push(x);
          });
        } else if (this.filtro.id == 3) {
          this.dessertscopy.forEach((x) => {
            if (!x.codigoRecepcion) vue.desserts.push(x);
          });
        }
      },
      suc_sel: function() {
        if (this.suc_sel) this.initialize(this.suc_sel.xnit.apikey);
        else this.initialize(null);
      },
    },

    created() {
      // this.initialize(null);
      this.getSucursalesBySede();
    },

    methods: {
      initialize(apikey) {
        let vue = this;
        vue.loading = true;
        this.desserts = [];
        this.dessertscopy = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo`,
          headers: {
            apikey: apikey ? apikey : this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.reverse();
            window.console.log('eventos:', data);
            data.forEach((x) => {
              vue.dessertscopy.push(x);
            });
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      getSucursalesBySede() {
        let sedeid = this.$store.state.CARGO.idsede;
        let vue = this;
        this.sucursales = [];
        this.desserts = [];
        this.desserts2 = [];
        vue.loadingsucursales = true;

        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`;
        let url2 = `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`;
        const promise = xaxios.get(url);
        const promise2 = xaxios.get(url2);

        Promise.all([promise, promise2])
          .then(function(values) {
            let data = values[0].data.data;

            let data2 = values[1].data.data;
            data2.map((x) => {
              x.xtext = `${x.nro} [${x.tipo_facturacion}]`;
            });
            let xxxnits = [];

            data.map((x) => {
              x.xtext = `${x.sucursal.nro_nit} [${x.sucursal.numero_sucursal}]`;
              let n = data2.find((n) => n.nro == x.sucursal.nro_nit);
              x.xnit = n;
              if (!n || !n.apikey) x.xnit = { apikey: 'nro_nit_apikey_not_found' };
              xxxnits.push(n);
            });

            vue.nits = xxxnits;
            vue.sucursales = data;
            vue.loadingsucursales = false;
            vue.suc_sel = vue.sucursales[0];
            // vue.getdatos(vue.sucursales[1]);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },

      newregevento(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigo = item.codigo;
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.numero_documento = item.numero_documento;
          e.codigoSucursal = item.codigoSucursal;
          e.descripcion = item.descripcion;
        } else {
          this.initialize();
        }
      },

      recepcionItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        let tok = null;
        if (this.suc_sel) tok = this.suc_sel.xnit.apikey;
        this.$refs.eventosrecep.openmodal(item, tok);
      },
      verEnvios(item) {
        let tok = null;
        if (this.suc_sel) tok = this.suc_sel.xnit.apikey;
        this.$router.push('/eventossigenvios?ideventosig=' + item.id + '&xky=' + tok);
      },

      editItem(item) {
        window.console.log("item",item);
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.eventosreg.openmodal(item);
      },

      verItem(item) {
        let tok = null;
        if (this.suc_sel) tok = this.suc_sel.xnit.apikey;
        this.$refs.eventoview.openmodal(item, tok);
      },
      verItemFacturas(item) {
        let tok = null;
        if (this.suc_sel) tok = this.suc_sel.xnit.apikey;
        this.$refs.eventosviewf.openmodal(item, tok);
      },

      finalizarItem(item) {
        let tok = null;
        if (this.suc_sel) tok = this.suc_sel.xnit.apikey;
        this.$refs.eventofin.openmodal(item, tok);
      },

      eventoFinalizado() {
        this.initialize();
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
    },
  };
</script>
